import { allCountries } from "@lib/constants/Country";
import { Select } from "antd";
import { SelectProps } from "antd/lib";
import { useMemo } from "react";

type PhoneCountryCodesProps = SelectProps & {
  startOver?: number[];
};

export default function PhoneCountryCodes(props?: PhoneCountryCodesProps) {
  const { startOver = [90], ...rest } = props;

  const filteredCountries = useMemo(() => {
    const startOverCountries = allCountries.filter((item) =>
      item.phoneCode.some((code) => startOver?.includes(code)),
    );
    const otherCountries = allCountries.filter(
      (item) => !item.phoneCode.some((code) => startOver?.includes(code)),
    );
    return [...startOverCountries, ...otherCountries];
  }, [startOver]);

  return (
    <Select style={{ width: 90 }} showSearch size="small" {...rest}>
      {filteredCountries.map((item, key) => (
        <Select.Option
          key={`${item.phoneCode[0]}-${key}`}
          value={`+${item.phoneCode[0]}`}
        >
          +{item.phoneCode[0]}
        </Select.Option>
      ))}
    </Select>
  );
}
